'use strict';

import React from 'react'

import { MdOutlineInstallMobile } from 'react-icons/md'
import { CiMobile3 } from 'react-icons/ci'

import Layout   from '@Layout/BackOffice'
import Loader   from '@Pure/Loader'
import DataList from '@/DataList'

import EC_members_config   from '@Config/EC/EC_member'
import ECs_config          from '@Config/EC/EC'

import show_product_config from '@Config/Catalog/show_product'
import Providers_config    from '@Config/Catalog/provider'

import _ from 'lodash'

const { app, qwest } = window;

export default class DashboardPage extends React.Component
{
	constructor (props)
	{
		super();

		this.state =
		{
			loading: true,

			members: 0,
			ECs: 0,
			app_installs: 0,
			app_active_users: 0
		};
	}

	UNSAFE_componentWillMount ()
	{
		var component = this, props = this.props;

		app.resetFunctions();

		qwest.post('/dashboard')
		.then(function (xhr, response)
		{
			component.setState(
			{
				members: response.members,
				ECs: response.ECs,
				app_installs: response.app_installs,
				app_active_users: response.app_active_users,

				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, xhr, response);

			app.ajaxRedirectLogin(response);

			component.setState(
			{
				loading: false
			});
		});
	}

	render ()
	{
		const component = this, props = this.props;

		var loader;

		var configs =
		{
			EC_members: _.cloneDeep(EC_members_config),
			ECs: _.cloneDeep(ECs_config),
			show_product: _.cloneDeep(show_product_config),
			providers: _.cloneDeep(Providers_config)
		};

		delete configs.ECs.header_map['Renouvellement'];

		delete configs.show_product.header_map['Artiste'];

		delete configs.EC_members.header_map['Prénom'];
		delete configs.EC_members.header_map['Nom'];
		delete configs.EC_members.header_map['Date de création'];

		var EC_columns = ['Logo', 'Entreprise', 'Ville'], EC_header = { };

		EC_columns.forEach(function (column)
		{
			if (!configs.ECs.header_map[column]) return;

			EC_header[column] = configs.ECs.header_map[column];
		});

		configs.ECs.header_map = EC_header;

		Object.keys(configs).forEach(function (config_name)
		{
			if (configs[config_name].filter_query)
			{
				Object.assign(configs[config_name].filter_query,
				{
					limit: 4,
					sort: 'createdAt DESC'
				});
			}
			else
			{
				Object.assign(configs[config_name],
				{
					filter_query:
					{
						limit: 4,
						sort: 'createdAt DESC'
					}
				});
			}
		});

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['yellow', 'bg-white'] } />;
		}

		var output =
		(
			<Layout history={ props.history } page_title="Tableau de bord">

				<div className="page-content">

					<div className="o-grid-4 u-flex">

						<div className="o-grid__item u-flex">

							<div className="c-color-block c-color-block--blue">
								{ loader }

								<svg className="o-svg-icon o-svg-icon--user c-color-block__icon">
									<use xlinkHref="/images/icons.svg#svg-icon-user"></use>
								</svg>

								<div className="c-color-block__title">
									{ component.state.members }
								</div>

								<div className="c-color-block__txt">
									Utilisateurs validés
								</div>

							</div>

						</div>

						<div className="o-grid__item u-flex">

							<div className="c-color-block">
								{ loader }

								<svg className="o-svg-icon o-svg-icon--blog c-color-block__icon">
									<use xlinkHref="/images/icons.svg#svg-icon-blog"></use>
								</svg>

								<div className="c-color-block__title">
									{ component.state.ECs }
								</div>

								<div className="c-color-block__txt">
									Comités d'Entreprise
								</div>

							</div>

						</div>

						<div className="o-grid__item u-flex">

							<div className="c-color-block c-color-block--orange">
								{ loader }

								<MdOutlineInstallMobile className="o-svg-icon o-svg-icon--installs
									c-color-block__icon"
								/>

								<div className="c-color-block__title">
									{ component.state.app_installs }
								</div>

								<div className="c-color-block__txt">
									Installations de l'appli mobile
								</div>

							</div>

						</div>

						<div className="o-grid__item u-flex">

							<div className="c-color-block c-color-block--purple">
								{ loader }

								<CiMobile3 className="o-svg-icon o-svg-icon--mobile
									c-color-block__icon"
								/>

								<div className="c-color-block__title">
									{ component.state.app_active_users }
								</div>

								<div className="c-color-block__txt">
									Utilisateurs actifs de l'application mobile
								</div>

							</div>

						</div>

					</div> { /* /o-grid */ }

					<div className="o-grid-2">

						<div className="o-grid__item">
							<div className="dashboard-list">
								<DataList add_btn={ false } pagination={ false }
									config={ configs.EC_members }
									hide_search true-pagination
								/>
							</div>

							<div className="dashboard-list">
								<DataList add_btn={ false } pagination={ false }
									config={ configs.ECs }
									hide_search true-pagination
								/>
							</div>
						</div>

						<div className="o-grid__item">
							<div className="dashboard-list">
								<DataList add_btn={ false } pagination={ false }
									config={ configs.show_product }
									hide_search true-pagination
								/>
							</div>

							<div className="dashboard-list">
								<DataList add_btn={ false } pagination={ false }
									config={ configs.providers }
									hide_search true-pagination
								/>
							</div>
						</div>

					</div> { /* /o-grid */ }

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}